import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { LoaderService, ToastService } from '@mtgame/ui';
import { StatisticService } from '@core/services/statistic.service';
import { ROUND_QUERY_PARAM, SEASON_QUERY_PARAM, TOURNAMENT_QUERY_PARAM } from '@config/routing-map';

@Injectable()
export class StatisticResolver implements Resolve<any> {
  constructor(
    private loaderService: LoaderService,
    private toastService: ToastService,
    private statisticService: StatisticService,
  ) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    this.loaderService.show();
    try {
      return await this.statisticService.initialize(
        +route.queryParams[SEASON_QUERY_PARAM],
        +route.queryParams[TOURNAMENT_QUERY_PARAM],
        +route.queryParams[ROUND_QUERY_PARAM],
      );
    } catch (e) {
      this.toastService.danger('Произошла ошибка');
      throw e;
    } finally {
      this.loaderService.hide();
    }
  }
}
